module.exports = __webpack_public_path__ + "img/chair.76070114.svg";